import UiStore from "./ui";
import AppStore from "./app";

export default class RootStore {
  constructor() {
    this.uiStore = new UiStore(this);
    this.appStore = new AppStore(this);
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js